import * as React from "react";
const Mountains = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#3F3F3F", d: "M24.2 47.6 48 95.1H.5z" }),
        React.createElement("path", { fill: "#CFCFCF", d: "m55.9 16 39.6 79.2H16.3z" }),
        React.createElement("path", { fill: "#ED0000", d: "M24.9 28.2c6.572 0 11.9-5.327 11.9-11.9 0-6.572-5.328-11.9-11.9-11.9S13 9.728 13 16.3c0 6.573 5.328 11.9 11.9 11.9" }))));
export default Mountains;
//# sourceMappingURL=Mountains.js.map